import _ from 'lodash';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import invariant from 'invariant';

import { getRegion } from 'reducers/selectors/user';
import { LOAD_CONFIG } from '../constants';
import {
  pendingLoadConfig,
  configLoaded,
  loadSession,
  configLoadingError,
} from '../actions';
import middleware, { staticDefaultParams, updateDefaults } from '../service';

export function* setupAsyncClient() {
  yield put(pendingLoadConfig());

  try {
    const config = yield call([Reflect, 'get'], window, 'getConfig');

    invariant(
      !_.isEmpty(config),
      '(Music/saga...) setupAsyncClient: Client config not defined',
    );

    const region = yield select(getRegion);

    const params = _.pick(config, ['authpn', 'authpt']);
    const baseURL = _.get(config, 'url_middleware_claro_musica');
    const middlewareParams = _.merge(staticDefaultParams, params, { region });

    updateDefaults(middleware, { baseURL, params: middlewareParams });

    yield put(configLoaded());
  } catch (error) {
    yield put(configLoadingError(error));
  }
}

export default function* configSaga() {
  yield takeLatest(LOAD_CONFIG.ACTION, setupAsyncClient);
}
